import React from 'react';
import { BlockedTabLink, TabLink } from './TabMenuLink.styles';

type TabMenuLinkProps = {
  to: string;
  children: React.ReactNode;
  isBlocked?: boolean;
  'data-testid'?: string;
};

export const TabMenuLink = ({ isBlocked, children, ...rest }: TabMenuLinkProps) => {
  if (isBlocked) {
    return <BlockedTabLink>{children}</BlockedTabLink>;
  }

  return <TabLink {...rest}>{children}</TabLink>;
};
